<!-- 
  Corrigir tamanho texto/imagem
  Incorporar antigas páginas de Tecnologia, Escola e Família
  -->
<template>
  <section>
    <Banner value="Convênios e Parcerias" />
    <hr style="border:5px solid #DDD" />

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-4>
          <v-flex xs12>
            <p class="lead">{{ wrapper.description }}</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section
      v-for="atividade in wrapper.activities"
      :key="atividade.id"
      style="background:none;"
    >
      <v-container grid-list-xl>
        <v-layout justify-space-between row wrap my-4>
          <v-flex md3>
            <img
              v-if="atividade.avatar"
              class="img3d"
              :src="atividade.avatar"
              style="width:100%"
            />
          </v-flex>
          <v-flex md5>
            <h1 style="text-align:left; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">{{ atividade.title }}</span>
              <!-- <br>com o Prof. Gilmar das Neves -->
            </h1>
            <br />
            <div v-if="atividade.description">
              <p v-for="(p, iP) in atividade.description.split(`\n`)" :key="iP">
                {{ p }}
              </p>
            </div>
            <p>
              <img
                v-if="atividade.image"
                :src="atividade.image"
                style="width:100%"
              />
            </p>
            <div v-if="atividade.info">
              <div v-for="info in atividade.info" :key="info.id">
                <h4>{{ info.title }}</h4>
                <div
                  class="markdown"
                  v-html="compiledMarkdown(info.description)"
                ></div>
              </div>
            </div>
            <br />
            <table v-if="atividade.table_data && atividade.table_data.length">
              <tr
                v-for="(cols, row) in getTable(atividade.table_data).lines"
                :key="row"
              >
                <td v-for="(data, col) in cols" :key="col">{{ data }}</td>
              </tr>
            </table>
          </v-flex>

          <v-flex md3>
            <div v-for="label in atividade.labels" :key="label.id">
              <h4>{{ label.label }}</h4>
              <p class="lead">{{ label.value }}</p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import jsonData from "../../../public/api/v1/atividade/2.json";
var marked = require("marked");

class Table {
  constructor(datas) {
    this.numRows = 0;
    this.numCols = 0;
    this.lines = [];
    this._setNumRowsCols(datas);
    this._setLines(datas);
  }

  _getValue(datas, row, col) {
    let value = null;
    datas.forEach(function(data) {
      if (data.row === row && data.col === col) {
        value = data.value;
      }
    });
    return value;
  }

  _setNumRowsCols(datas) {
    let self = this;
    datas.forEach(function(data) {
      data.row > self.numRows ? (self.numRows = data.row) : null;
      data.col > self.numCols ? (self.numCols = data.col) : null;
    });
    self.numRows++;
    self.numCols++;
  }

  _setLines(datas) {
    for (let row = 0; row < this.numRows; row++) {
      let line = [];
      for (let col = 0; col < this.numCols; col++) {
        line.push(this._getValue(datas, row, col));
      }
      this.lines.push(line);
    }
  }
}

export default {
  data: () => ({
    wrapper: [],
    table: null, // tabela convertida
    datas: [
      { row: 0, col: 0, value: "Heading 1" },
      { row: 0, col: 1, value: "Heading 2" },
      { row: 0, col: 2, value: "Heading 3" },
      { row: 1, col: 0, value: "Data 1.1" },
      { row: 1, col: 1, value: "Data 2.1" },
      { row: 1, col: 2, value: "Data 3.1" },
      { row: 2, col: 0, value: "Data 1.2" },
      { row: 2, col: 1, value: "Data 2.2" },
      { row: 2, col: 2, value: "Data 3.2" },
      { row: 3, col: 0, value: "Data 1.3" },
      { row: 3, col: 1, value: "Data 2.3" },
      { row: 3, col: 2, value: "Data 3.3" },
    ],
  }),
  created: function() {
    this.wrapper = jsonData;
  },
  methods: {
    compiledMarkdown: function(value) {
      if (value) {
        return marked(value, { sanitize: true });
      }
    },
    getTable(tableData) {
      return new Table(tableData);
    },
  },
  mounted: function() {
    this.table = new Table(this.datas);
  },
  components: {
    Banner,
  },
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}

// div.markdown {
//   text-align: left !important;
//   color:red;
//   background: green;
//   border:1px solid black;
// }

ul,
ol {
  margin-bottom: 20px;
}

table {
  width: 100%;
  tr {
    &:first-child {
      td {
        color: white;
        font-weight: bold;
        background: #666;
        border: 1px solid #666;
      }
    }
    td {
      text-align: center;
      background: #fff;
      border: 1px solid #ddd;
      padding: 5px;
    }
  }
}

.img3d {
  width: 100%;
  transform: perspective(400px) rotateY(15deg);
  box-shadow: -5px 0px 10px #666;
}
</style>
